import {
    Alert,
    Button,
    ButtonText,
    EmailIcon,
    HStack,
    Icon,
    MessageIcon,
    PhoneIcon,
    Radio,
    RadioGroup,
    RadioIcon,
    RadioIndicator,
    RadioLabel,
    Text,
    VStack
} from "@hosttools/frontend";
import type {ChannelObject} from "@hosttools/frontend/models/channel";
import type {FC} from "react";
import {useCallback, useEffect, useState} from "react";

import type {Errors, Method} from "./types";

interface Props {
    channel: ChannelObject;
    methods: Method[];
    info: string;
    errors: Errors;
    buttonText: string;
    onChange: (code: number) => void;
    onSubmit?: () => void;
}

const Verification: FC<Props> = ({
    channel,
    methods,
    errors: initErrors,
    info = "",
    onChange,
    onSubmit,
    buttonText
}) => {
    const [methodIndex, setMethodIndex] = useState(0);
    const [errors, setErrors] = useState(initErrors);

    useEffect(() => {
        setErrors(initErrors);
    }, [initErrors]);

    const handleChangeMethodCode = useCallback(
        (code: string) => {
            setMethodIndex(Number(code));
            onChange(Number(code));
        },
        [onChange]
    );

    return (
        <VStack space="xl">
            <Text>
                {channel.label} needs to verify your account. Please choose from one of the options
                below.
            </Text>
            <RadioGroup value={methodIndex.toString()} onChange={handleChangeMethodCode}>
                <VStack className="max-w-full" space="md">
                    {methods.map((method, i) => {
                        const {type, message} = method;
                        return (
                            <Radio key={type} size="sm" value={i.toString()}>
                                <RadioIndicator>
                                    <RadioIcon />
                                </RadioIndicator>
                                <RadioLabel>
                                    <HStack className="max-w-full items-center" space="sm">
                                        {type === "sms" && (
                                            <Icon as={MessageIcon} fill="blueGray.400" size="sm" />
                                        )}
                                        {type === "call" && (
                                            <Icon as={PhoneIcon} fill="blueGray.400" size="sm" />
                                        )}
                                        {type === "email" && (
                                            <Icon as={EmailIcon} fill="blueGray.400" size="sm" />
                                        )}
                                        <Text color="blueGray.600" variant="sm">
                                            {message}
                                        </Text>
                                    </HStack>
                                </RadioLabel>
                            </Radio>
                        );
                    })}
                </VStack>
            </RadioGroup>
            {errors.error && <Alert action="error">{errors.error}</Alert>}
            {info && <Alert action="info">{info}</Alert>}
            <Button className="md:hidden" onPress={onSubmit}>
                <ButtonText>{buttonText}</ButtonText>
            </Button>
        </VStack>
    );
};

export default Verification;
